export default __webpack_public_path__ + "static/media/summerchallenge02.d6ad32ad.jpg";